// get hash params from url
export const getHashParams = (hash?: string): { [key: string]: string } => {
  if (!window && !hash) return;

  let e: any;
  const hashParams = {};
  const a = /\+/g; // Regex for replacing addition symbol with a space
  const r = /([^&;=]+)=?([^&;]*)/g;
  const d = (s: string) => decodeURIComponent(s.replace(a, ' '));
  const q = (hash || window.location.hash).substring(1);

  // eslint-disable-next-line no-cond-assign
  while ((e = r.exec(q))) hashParams[d(e[1])] = d(e[2]);

  return hashParams;
};
